export const MAX_PAST_LESSONS = 50;
